import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BrandingWatermarkIcon from '@mui/icons-material/BrandingWatermark';
import BuildIcon from '@mui/icons-material/Build';
import GroupIcon from '@mui/icons-material/Group';
import BusinessIcon from '@mui/icons-material/Business';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import AccountBoxSharpIcon from '@mui/icons-material/AccountBoxSharp';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import NotificationsIcon from '@mui/icons-material/Notifications';
import PaymentIcon from '@mui/icons-material/Payment';
import { CommonHelper } from 'src/utils/commonHelper';
import SvgColor from '../../../components/svg-color';
import ApiIcon from '@mui/icons-material/Api'; 
import StorefrontIcon from '@mui/icons-material/Storefront';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import { Brush as BrushIcon, Label as LabelIcon} from '@mui/icons-material';


const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

export const navSidebar = (translate) => {
  return [
    {
      title: translate('navbar.title.dashboard'),
      menu: [
        {
          title: translate('navbar.menu.dashboard'),
          path: '/dashboard',
          icon: icon('dashboard'),
          permissions: `${CommonHelper.PermissionList.READ_POST}`,
        },
        {
          title: translate('navbar.menu.published_post'),
          path: '/published-post',
          icon: icon('published-post'),
          permissions: `${CommonHelper.PermissionList.READ_POST}`,
        },
      ]
    },
    {
      title: translate('navbar.title.reports'),
      menu: [
        {
          title: translate('navbar.menu.social_media_report'),
          path: '/report',
          icon: icon('integration'),
          permissions: `${CommonHelper.PermissionList.READ_POST}`,
        },
        {
          title: translate('navbar.menu.custom_report'),
          path: '/custom-report',
          icon: icon('calendar'),
          permissions: `${CommonHelper.PermissionList.BRAND_ADMIN}`,
        },
        {
          title: translate('navbar.menu.schedule_report'),
          path: '/scheduled-report-view',
          icon: icon('schedule-report'),
          permissions: `${CommonHelper.PermissionList.READ_POST}`,
        },
      ]
    },
    {
      title: translate('navbar.title.post'),
      menu: [
        {
          title: translate('navbar.menu.new_post'),
          path: '/new-post',
          icon: icon('new-post'),
          permissions: `${CommonHelper.PermissionList.PUBLISH_PERMISSION}`,
        },
        {
          title: translate('navbar.menu.upcoming_post'),
          path: '/upcoming-post',
          icon: icon('scheduled-post'),
          permissions: `${CommonHelper.PermissionList.PUBLISH_PERMISSION}`,
        },
        {
          title: translate('navbar.menu.approval'),
          path: '/approval',
          icon: icon('approval'),
          permissions: `${CommonHelper.PermissionList.PUBLISH_PERMISSION}`,
        },
        {
          title: translate('navbar.menu.calender'),
          path: '/calendar',
          icon: icon('calendar'),
          permissions: `${CommonHelper.PermissionList.PUBLISH_PERMISSION}`,
        },
        {
          title: translate('navbar.menu.draft'),
          path: '/draft',
          icon: icon('draft'),
          permissions: `${CommonHelper.PermissionList.PUBLISH_PERMISSION}`,
        },
        {
          title: translate('navbar.menu.media_library'),
          path: '/media-library',
          icon: icon('media'),
          permissions: `${CommonHelper.PermissionList.PUBLISH_PERMISSION}`,
        },
      ],
    },
    {
      title: translate('navbar.title.social_accounts'),
      menu: [
        {
          title: translate('navbar.menu.integration'),
          path: '/integration',
          icon: icon('integration'),
          show_in_integsocial_left_pane: true,
          permissions: `${CommonHelper.PermissionList.INTEGRATE_PERMISSION}`,
        },
      ],
    },
    {
      title: translate('navbar.title.crm'),
      menu: [
        {
          title: `${translate('autodm_info.social_crm')} (Beta)`,
          path: '/crm',
          icon: icon('message'),
          show_in_integsocial_left_pane: true,
          permissions: `${CommonHelper.PermissionList.READ_POST}`,
        },
      ]
    },
    {
      title: translate('navbar.title.auto_post'),
      menu: [
        {
          title: translate('navbar.menu.auto_post'),
          path: '/auto-post',
          icon: icon('auto-post'),
          permissions: `${CommonHelper.PermissionList.PUBLISH_PERMISSION}`,
        },
        {
          title: translate('navbar.menu.cross_post'),
          path: '/automation',
          icon: icon('automation-post'),
          permissions: `${CommonHelper.PermissionList.PUBLISH_PERMISSION}`,
        },
      ],
    },
    {
      title: translate('navbar.title.messages'),
      menu: [
        {
          title: translate('autodm_info.auto_dm'),
          path: '/auto-dm',
          icon: icon('approval'),
          show_in_integsocial_left_pane: true,
          permissions: `${CommonHelper.PermissionList.PUBLISH_PERMISSION}`,
        },
        {
          title: translate('navbar.menu.social_inbox'),
          path: '/message',
          icon: icon('message'),
          show_in_integsocial_left_pane: true,
          permissions: `${CommonHelper.PermissionList.MANAGE_SOCIAL_INBOX}`,
        },
        {
          title: translate('navbar.menu.ai_message'),
          path: '/ai-message',
          icon: icon('message'),
          permissions: `${CommonHelper.PermissionList.PUBLISH_PERMISSION}`,
        },
      ],
    },
  ];
};

export const getSettingsMenu = (translate) => {
  return [
    {
      title: translate('navbar.menu.profile'),
      menu: [
        {
          title: translate('profile.general.title'),
          path: '/profile',
          icon: <AccountCircleIcon />,
          show_in_integsocial_left_pane: true,
          permissions: `${CommonHelper.PermissionList.READ_POST}`,
        },
        {
          title: translate('profile.change_password.title'),
          path: '/change-password',
          icon: <VpnKeyIcon sx={{ width: '20px', height: '20px' }} />,
          show_in_integsocial_left_pane: true,
          permissions: `${CommonHelper.PermissionList.READ_POST}`,
        },
        {
          title: translate('profile.profile_details.title'),
          path: '/profile-details',
          icon: <AccountBoxSharpIcon />,
          show_in_integsocial_left_pane: true,
          permissions: `${CommonHelper.PermissionList.READ_POST}`,
        },
        {
          title: 'Coupon Update',
          path: '/coupon-update',
          hide_in_left_pane: true,
          icon: <ConfirmationNumberIcon />,
          permissions: `${CommonHelper.PermissionList.ORG_ADMIN}`,
        },
      ],
    },
    {
      title: translate('navbar.menu.brand_settings'),
      menu: [
        {
          title: translate('manage_brand.tabs.brand_info'),
          path: '/manage-brand',
          icon: <AccountBoxSharpIcon />, 
          show_in_integsocial_left_pane: true,
          permissions: `${CommonHelper.PermissionList.READ_POST}`,
        },
        {
          title: translate('manage_brand.tabs.manage_roles'),
          path: '/manage-roles',
          icon: <SupervisorAccountIcon />, 
          show_in_integsocial_left_pane: true,
          permissions: `${CommonHelper.PermissionList.BRAND_ADMIN}`,
        },
        {
          title:  translate('manage_brand.tabs.manage_users'),
          path: '/manage-users',
          icon: <ManageAccountsIcon />, 
          show_in_integsocial_left_pane: true,
          permissions: `${CommonHelper.PermissionList.BRAND_ADMIN}`,
        },
        {
          title: translate('manage_brand.tabs.pending_users'),
          path: '/pending-users',
          icon: <ManageAccountsIcon />, 
          show_in_integsocial_left_pane: true,
          permissions: `${CommonHelper.PermissionList.BRAND_ADMIN}`,
        },
      ],
    },
    {
      title: translate('navbar.menu.manage_organization'),
      menu: [
        {
          title: translate('manage_organization.organization_info.title'),
          path: '/manage-organization',
          icon: <BusinessIcon />,
          show_in_integsocial_left_pane: true,
          permissions: `${CommonHelper.PermissionList.READ_POST}`,
        },
        {
          title: translate('navbar.menu.manage_brand'),
          path: '/manage-org-brands',
          icon: <BuildIcon />,
          show_in_integsocial_left_pane: true,
          permissions: `${CommonHelper.PermissionList.ORG_ADMIN}`,
        },
        {
          title: translate('manage_organization.manage_users_title'),
          path: '/manage-org-users',
          icon: <GroupIcon />,
          show_in_integsocial_left_pane: true,
          permissions: `${CommonHelper.PermissionList.ORG_ADMIN}`,
        },
      ],
    },
    {
      title:  translate('navbar.menu.manage_biling'),
      menu: [
        {
          title: translate('navbar.menu.manage_biling'),
          path: '/billing',
          icon: <PaymentIcon />,
          permissions: `${CommonHelper.PermissionList.ORG_ADMIN}`,
          portalAdmin: true,
        },
      ],
    },
    {
      title:  translate('navbar.menu.branding'),
      menu: [
        {
          title: translate('navbar.menu.branding'),
          path: '/branding',
          icon: <BrandingWatermarkIcon />,
          show_in_integsocial_left_pane: true,
          permissions: `${CommonHelper.PermissionList.ORG_ADMIN}`,
        },
        {
          title: translate('trail_plan.white_label'),
          path: '/white-label',
          icon: <BrushIcon />,
          show_in_integsocial_left_pane: true,
          permissions: `${CommonHelper.PermissionList.ORG_ADMIN}`,
        },
        {
          title:  translate('manage_branding.branding.custom_email'),
          path: '/custom-email',
          icon: <LabelIcon />,
          show_in_integsocial_left_pane: true,
          permissions: `${CommonHelper.PermissionList.ORG_ADMIN}`,
        },
      ],
    },
    {
      title: translate('navbar.menu.notification_settings'),
      menu: [
        {
          title: translate('navbar.menu.notification_settings'),
          path: '/notification-settings',
          icon: <NotificationsIcon />,
          permissions: `${CommonHelper.PermissionList.READ_POST}`,
        },
      ],
    },
    {
      title: 'API (Beta)',
      menu: [
        {
          title: 'API (Beta)',
          path: '/handle-api',
          icon: <ApiIcon />,
          permissions: `${CommonHelper.PermissionList.ORG_ADMIN}`,
        }
      ],
    },
    {
      title: 'Reseller (Beta)',
      menu: [
        {
          title: 'Reseller (Beta)',
          path: '/handle-reseller',
          icon: <StorefrontIcon />,
          permissions: `${CommonHelper.PermissionList.ORG_ADMIN}`,
        }
      ],
    },
    {
      title: translate('navbar.menu.refer_and_earn'),
      menu: [
        {
          title: translate('navbar.menu.refer_and_earn'),
          path: '/refer-earn',
          icon: <GroupAddIcon />,
          permissions: `${CommonHelper.PermissionList.READ_POST}`,
        },
      ],
    },
  ];
};

export const navMobilebar = (translate) => {
  return [
    { title: translate('navbar.menu.published_post'), path: '/published-post', icon: icon('published-post') },
    { title: translate('navbar.menu.new_post'), path: '/new-post', icon: icon('new-post') },
    { title: translate('navbar.menu.calendar'), path: '/calendar', icon: icon('calendar') },
    { title: translate('navbar.menu.integration'), path: '/integration', icon: icon('integration') },
  ];
};
